// extracted by mini-css-extract-plugin
module.exports = {"error-response":"server_errors__error-response___tR7g4","errorResponse":"server_errors__error-response___tR7g4"};